import { colors } from '../../../ui-components';

class ContentGrid {
  constructor(contentfulNode) {
    this.headline = contentfulNode?.headline;
    this.subHeadline = contentfulNode?.subHeadline;
    this.subHeadlineUnderline = contentfulNode?.subHeadline;
    this.gridItems = contentfulNode?.gridItems;
    this.headlineText = contentfulNode?.headlineText?.headlineText;
    this.ctaLinkLabel = contentfulNode?.ctaLinkLabel;
    this.ctaLinkUrl = contentfulNode?.ctaLinkUrl;
    this.defaultColor = contentfulNode?.backgroundColor ? colors[contentfulNode.backgroundColor] : colors.pureWhite;
    this.type = contentfulNode?.specialSection ? contentfulNode?.specialSection : 'CONTENT_GRID';
  }
}

export { ContentGrid };
